import PropTypes from "prop-types"
import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { t } from "../../i18next"
import { PageNotFound } from "../common"
import * as actions from "./redux/actions"
import { CONTACT_ADDRESS_CODES, DamageCaseIdShape, DELIVERY_ADDRESS_CODES, FeatureStateShape } from "./redux/shapes"
import { DamageCasePage, DamageCasePageHeader, DamageCaseNavigation } from "."

export class CommunicationsPage extends Component {
  static propTypes = {
    damageCase: FeatureStateShape.isRequired,
    actions: PropTypes.object.isRequired,
    caseId: DamageCaseIdShape.isRequired,
  }

  render() {
    const { caseId } = this.props
    const { unsentCases } = this.props.damageCase
    const currentCase = unsentCases[caseId]

    if (currentCase) {
      return this.renderCase(currentCase)
    } else {
      return <PageNotFound />
    }
  }

  renderCase(currentCase) {
    const { caseId } = this.props

    const submitCasePending = Boolean(this.props.damageCase.submitCasePending.find(id => id === caseId))
    const submitCaseError = this.props.damageCase.submitCaseError[caseId]
    const dismissSubmitCaseError = () => this.props.actions.dismissSubmitCaseError(caseId)

    const { contactAddressCode, copiesToContactAddressCodes, deliveryAddressCode } = currentCase

    return (
      <DamageCasePage
        className="damage-case-communications-page"
        submitPending={submitCasePending}
        submitError={submitCaseError}
        dismissSubmitCaseError={dismissSubmitCaseError}
      >
        <DamageCasePageHeader caseId={caseId} />
        <div className="app-content">
          <DamageCaseNavigation className="app-content_left" caseId={caseId} currentPage="communications" />
          <div className="app-content_middle">
            <h2>{t("damageCase.contactAddress")}</h2>
            <div className="contact-address chewbacca">
              {CONTACT_ADDRESS_CODES.map(val => (
                <button
                  key={val}
                  className={`item ${contactAddressCode === val ? "selected" : ""}`}
                  onClick={() => this.toggleSingleValue("contactAddressCode", contactAddressCode, true)(val)}
                >
                  {t(`damageCase.addressCodes.${val}`)}
                </button>
              ))}
            </div>
          </div>
          <div className="app-content_middle">
            <h2>{t("damageCase.copiesToContactAddresses")}</h2>
            <div className="copy-to chewbacca">
              {CONTACT_ADDRESS_CODES.map(val => (
                <button
                  key={val}
                  className={`item ${copiesToContactAddressCodes.includes(val) ? "selected" : ""}`}
                  onClick={() => this.toggleCopyTo(val)}
                >
                  {t(`damageCase.addressCodes.${val}`)}
                </button>
              ))}
            </div>
          </div>
          <div className="app-content_middle">
            <h2>{t("damageCase.deliveryAddress")}</h2>
            <div className="delivery-address chewbacca">
              {DELIVERY_ADDRESS_CODES.map(val => (
                <button
                  key={val}
                  className={`item ${deliveryAddressCode === val ? "selected" : ""}`}
                  onClick={() => this.toggleSingleValue("deliveryAddressCode", deliveryAddressCode, false)(val)}
                >
                  {t(`damageCase.addressCodes.${val}`)}
                </button>
              ))}
            </div>
          </div>
        </div>
      </DamageCasePage>
    )
  }

  toggleCopyTo = code => this.props.actions.toggleCopyTo(this.props.caseId, code)

  toggleSingleValue = (key, initialValue, isContactAddress) => value =>
    this.props.actions.rememberAttribute(
      this.props.caseId,
      key,
      value !== initialValue ? value : null,
      isContactAddress,
    )
}

/* istanbul ignore next */
function mapStateToProps(state, ownProps) {
  const { caseId } = ownProps.match.params

  return {
    damageCase: state.damageCase,
    caseId,
  }
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CommunicationsPage)



// WEBPACK FOOTER //
// ./src/features/damage-case/CommunicationsPage.js